// Initials colors
export const initialsColors = [
  "red",
  "pink",
  "purple",
  "deep-purple",
  "indigo",
  "blue",
  "light-blue",
  "cyan",
  "teal",
  "green",
  "light-green",
  "lime",
  "yellow",
  "amber",
  "orange",
  "deep-orange",
  "brown",
  "blue-grey",
  "grey",
];

// Gets a color based on initials
export const getColorForInitials = (ini: string): string => {
  let hash = 0;
  for (let i = 0; i < ini.length; i++) {
    hash = ini.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % initialsColors.length;
  return initialsColors[index];
};
